import _ from 'lodash'

import { SET_ADMIN_AUTH } from './mutation-types'

export default {
  [SET_ADMIN_AUTH](state, auth) {
    state.auth = _.cloneDeep(auth)
  },
}



// WEBPACK FOOTER //
// ./src/store/adminPermissionStore/mutations.js